import { Answer, Toggle } from '../generated/graphql';

export interface QuestionaryForm {
  answers?: Answer[];
  commentHealth: string;
}

export const ToggleKeys = Object.keys(Toggle);
